<template>
  <section
    id="cover"
    class="te-first-sidejob-cover-wrap relative border-b px-0 pb-7 text-center"
  >
    <div
      class="te-bg-first-sidejob-cover-second absolute w-full"
      style="z-index: 1"
    />
    <div class="te-first-sidejob-title-inner">
      <div
        class="te-first-sidejob-cover-header relative flex flex-col justify-center px-0 pt-5 md:justify-start lg:pt-[3.25rem]"
        style="z-index: 2"
      >
        <h2 class="mb-4 flex justify-center tracking-normal">
          <img
            class="mr-2"
            src="~/assets/images/Te/TeCourse/FirstSidejob/Cover/beginner-mark.svg"
            alt="マーク"
            height="32"
          >
          <span class="co-display-11 inline-block border-y border-co-primary-400 py-1 font-bold">
            はじめての副業コース
          </span>
        </h2>
        <h3 class="mb-0 block md:hidden">
          <img
            src="~/assets/images/Te/TeCourse/FirstSidejob/Cover/mobile-catch-text.svg"
            alt="受講から案件の納品まで常にプロが伴走"
            class="mx-auto h-20"
          >
        </h3>
        <h3 class="mb-4 hidden font-bold text-co-primary-400 md:block">
          <span class="te-first-sidejob-cover-title-pc-big">受講</span>
          <span class="te-first-sidejob-cover-title-pc">から</span>
          <span class="te-first-sidejob-cover-title-pc-big">案件の納品</span>
          <span class="te-first-sidejob-cover-title-pc">まで</span>
          <br>
          <span class="te-first-sidejob-cover-title-pc-big">常にプロが伴走</span>
        </h3>
        <img
          class="mx-auto mb-1 block w-full px-3 md:hidden"
          src="~/assets/images/Te/TeCourse/FirstSidejob/Cover/badge-pc-wrap.svg"
          alt="案件保証5万円分案件提供※、Adobeデザインツール無料、受講料最大70%キャッシュバック"
          style=" max-width: 23.4375rem; height: 8.625rem;margin-top: 9.25rem"
        >
        <div class="mb-3 text-center xl:mb-8">
          <img
            class="te-first-sidejob-icon-badge-pc mx-auto hidden md:block"
            src="~/assets/images/Te/TeCourse/FirstSidejob/Cover/badge-pc-wrap.svg"
            alt="案件保証5万円分案件提供※、Adobeデザインツール無料、受講料最大70%キャッシュバック"
          >
        </div>
        <div class="mb-4">
          <a
            href="#apply"
            class="co-btn-primary"
            @click.prevent="scrollTo('apply')"
          >
            今すぐ申し込む
            <FontAwesomeIcon
              :icon="faAngleRight"
              class="fa-fw inline h-4 w-5"
            />
          </a>
        </div>
        <TeCourseFirstSidejobCoverTimeSpan :closes-at="closesAt" />
        <a
          class="co-display-12 mb-5 inline-block md:mb-3"
          href="https://ceoclone.com/kiramex-techacademy/01J4JM0YVCQC45PPFJAC0VFEG1"
          target="_blank"
        >サービス説明動画（無料）を見る</a>
        <p
          class="mx-4 mb-0 text-left text-co-gray-400 sm:text-center md:mx-0"
          style="font-size: 0.625rem"
        >
          ※2024年8月5日以降にお申し込みされた方が対象
        </p>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import TeCourseFirstSidejobCoverTimeSpan from '~/components/Te/TeCourse/FirstSidejob/TeCourseFirstSidejobCoverTimeSpan.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faAngleRight } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faAngleRight,
    }
  },
  props: {
    closesAt: {
      type: Date,
      default: null,
    },
  },
  components: {
    TeCourseFirstSidejobCoverTimeSpan,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-first-sidejob-cover-wrap {
  height: auto;
  background: #fff;
  @media (min-width: 768px) {
    height: 28.125rem;
    max-height: 28.125rem;
  }
  @media (min-width: 1200px) {
    min-height: 34.375rem;
    background: #e4e3e8;
  }
}

.te-bg-first-sidejob-cover-second {
  height: 27.5rem;
  background-image: url('~/assets/images/Te/TeCourse/FirstSidejob/Cover/bg-cover-sp-woman.jpg');
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  @media (min-width: 768px) {
    height: 28.125rem;
    background-image: url('~/assets/images/Te/TeCourse/FirstSidejob/Cover/bg-cover-tablet-woman.jpg');
    background-position: bottom;
  }
  @media (min-width: 1200px) {
    height: auto;
    background-image: none;
  }
}

.te-first-sidejob-icon-badge-pc {
  max-width: 18.75rem;
  height: 4.875rem;
  @media (min-width: 992px) {
    max-width: 100%;
  }
  @media (min-width: 1200px) {
    height: 7.5rem;
  }
}

.te-first-sidejob-title-inner {
  width: 100%;
  @media (min-width: 1200px) {
    max-width: 90rem;
    min-height: 34.375rem;
    margin: 0 auto;
    background-image: url('~/assets/images/Te/TeCourse/FirstSidejob/Cover/bg-cover-3.webp');
    background-repeat: no-repeat;
    background-size: cover;
  }
}

.te-first-sidejob-cover-header {
  width: 100%;
  @media (min-width: 768px) {
    width: 25rem;
    margin-left: 1.25rem;
  }
  @media (min-width: 992px) {
    width: 28.875rem;
  }
  @media (min-width: 1200px) {
    margin-left: 6.25rem;
  }
  @media (min-width: 1440px) {
    margin-left: 10rem;
  }
}

.te-first-sidejob-cover-title-pc-big {
  font-size: 1.5rem;
  @media (min-width: 1200px) {
    font-size: 2.5rem;
  }
}

.te-first-sidejob-cover-title-pc {
  font-size: 1rem;
  @media (min-width: 1200px) {
    font-size: 1.75rem;
  }
}
</style>
